module.exports = __webpack_public_path__ + "static/img/BG_01.08bb1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BG_01.jpg
// module id = tnzp
// module chunks = 1